var i18n = {
	locale: document.documentElement.lang || 'ru',
	messages: {
		'ru': {
			'Invalid value': 'Некорректное значение',
			'Value missing': 'Заполните поле',
			'Unknown error': 'Неизвестная ошибка',
		},
		'vn': {
			'Invalid value': 'Invalid value',
			'Value missing': 'điền vào mẫu',
			'Unknown error': 'Unknown error',
		},
		'en': {
			'Invalid value': 'Invalid value',
			'Value missing': 'Fill in the field',
			'Unknown error': 'Unknown error',
		},
		'ua': {
			'Invalid value': 'Некоректне значення',
			'Value missing': 'Заповніть поле',
			'Unknown error': 'Неизвестная ошибка',
		},
		'th': {
			'Invalid value': 'ค่าไม่ถูกต้อง',
			'Value missing': 'กรอกข้อมูลในช่อง',
			'Unknown error': 'ข้อผิดพลาดที่ไม่รู้จัก',
		},
		'lt': {
			'Invalid value': 'Netinkama vertė',
			'Value missing': 'Užpildykite laukelį',
			'Unknown error': 'Nežinoma klaida',
		},
		'lv': {
			'Invalid value': 'Nederīga vērtība',
			'Value missing': 'Vērtība trūkst',
			'Unknown error': 'Nezināma kļūda',
		},
		'st': {
			'Invalid value': 'Vigane väärtus',
			'Value missing': 'Väärtus puudub',
			'Unknown error': 'Tundmatu viga',
		},
		'uz': {
			'Invalid value': 'Qabul qilinadigan qiymat',
			'Value missing': 'Hech qanday qiymat yo\'q',
			'Unknown error': 'Noma\'lum xato',
		},
		'kz': {
			'Invalid value': 'Жол берілмейтін мәні',
			'Value missing': 'Мән жоқ',
			'Unknown error': 'Белгісіз қате',
		},
	},
	gettext: function(text) {
		var lang = i18n.messages[i18n.locale] ? i18n.locale : 'ru';

		return i18n.messages[lang][text] || text;
	},
};


export default i18n;
